var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areaCascader"},[_c('el-cascader',{ref:"areaCascader",attrs:{"props":_vm.props,"show-all-levels":false,"clearable":"","collapse-tags":"","placeholder":_vm.$l(_vm.title),"filterable":_vm.filterable},on:{"change":_vm.change},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }